import { defineStore } from 'pinia';
import { ref } from 'vue';

interface ReferenceSelection {
  renderId: string;
  index: number;
  selectedParagraphs: string[];
}

export const useReferenceSelectionStore = defineStore(
  'referenceSelection',
  () => {
    const selectedReference = ref<ReferenceSelection | undefined>();

    const selectReference = (
      renderId: string,
      index: number,
      selectedParagraphs: string[]
    ) => {
      selectedReference.value = { renderId, index, selectedParagraphs };
    };

    const resetSelection = () => {
      selectedReference.value = undefined;
    };

    return {
      selectedReference,
      selectReference,
      resetSelection
    };
  }
);
